import React from 'react';
import { Icon } from '../../common/commonModels';
import TileComponent from '../../components/utils/TileComponent';
import { PalletBox } from '../../models/pallet-box';
import moment from 'moment';

interface Props {
  title: string;
  palletBox: PalletBox;
  iconClassName: Icon;
  flagged: boolean;
}

// tslint:disable-next-line:function-name
export default function ShipmentsTileComponentV2({
  title,
  palletBox,
  iconClassName,
  flagged,
}: Props) {
  return (
    <TileComponent
      title={title}
      iconClassName={iconClassName}
      topRightLabelText={`${palletBox.shipmentCount}`}
      bottomRightIconClassName={flagged ? 'fa-clock-o text-danger' : undefined}
      bottomRightIconTitle={`Pallet box created ${moment(palletBox.createdAt).fromNow()}`}
    />
  );
}
